/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React from 'react';
import { Box } from '@mui/material';
import { CustomTooltip } from './tooltip_component';
import kmzNetworkIcon from '../../Assets/SideNavIcons/kmzNetwork.svg';
import { getPermissions } from '../functions/get_permissions_from_storage.function';
import {
  hasAnyPermission,
  PARTNER_NETWORK_PERMISSIONS,
  RING_PLANNING_PERMISSIONS,
  KMZ_PERMISSIONS,
} from '../functions/permission_utils.function';

export const PartnerNetworkLeftBarPath = (props) => {
  const { selectedIcon, activeItemStyle, iconStyle, handleIconClick, hideTooltip = false } = props;

  // Get user permissions to determine which module to navigate to
  const permissions = getPermissions();
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];

  // Determine which module to navigate to based on permissions
  const getNavigationTarget = () => {
    if (hasAnyPermission(permissionNames, PARTNER_NETWORK_PERMISSIONS)) {
      return 'Partner Network';
    }
    if (hasAnyPermission(permissionNames, KMZ_PERMISSIONS)) {
      return 'KMZ';
    }
    if (hasAnyPermission(permissionNames, RING_PLANNING_PERMISSIONS)) {
      return 'Ring Planning';
    }
    return 'Partner Network'; // Default fallback
  };

  const iconContent = (
    <Box
      style={selectedIcon === 2 ? activeItemStyle : iconStyle}
      onClick={() => handleIconClick(2, getNavigationTarget())}
    >
      <img src={kmzNetworkIcon} alt="Network Planning" width="20" height="20" />
    </Box>
  );

  return (
    <>
      {hideTooltip ? (
        iconContent
      ) : (
        <CustomTooltip title="Network Planning">{iconContent}</CustomTooltip>
      )}
    </>
  );
};
